module.exports = __webpack_public_path__ + "static/media/WhiteFaceTagline.638855ea.png";